(() => {
  if (customElements.get('cooldo-product-upsells')) return;
  class CooldoProductUpsells extends HTMLElement {
    connectedCallback() {
      this.activeFilter = this.dataset.defaultFilter || 'all';
      this.syncCards();
      this.onCartChange = (event) => {
        if (event.type === 'cart:updated' && window.iuropCart) return;
        if (event.type === 'iurop:cart-rendered') {
          if (event.detail?.key === this.dataset.cartKey) return;
        }
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.refresh(), 180);
      };
      this.onClick = (event) => {
        const button = event.target.closest('[data-upsell-add]');
        if (button && this.contains(button)) this.add(button);
        const filter = event.target.closest('[data-recommendation-filter]');
        if (filter && this.contains(filter)) {
          this.activeFilter = filter.dataset.recommendationFilter;
          this.syncCards();
        }
      };
      document.addEventListener('cart:updated', this.onCartChange);
      document.addEventListener('iurop:cart-rendered', this.onCartChange);
      this.addEventListener('click', this.onClick);
    }
    disconnectedCallback() {
      clearTimeout(this.refreshTimer);
      this.request?.abort();
      document.removeEventListener('cart:updated', this.onCartChange);
      document.removeEventListener('iurop:cart-rendered', this.onCartChange);
      this.removeEventListener('click', this.onClick);
    }
    syncCards() {
      const seen = new Set([this.dataset.productId].filter(Boolean));
      this.querySelectorAll('[data-upsell-product-id]').forEach((card) => {
        const id = card.dataset.upsellProductId;
        if (seen.has(id)) card.remove();
        else seen.add(id);
      });
      const cards = [...this.querySelectorAll('[data-recommendation-card]')];
      const categories = new Set(cards.map((card) => card.dataset.category).filter((category) => category === 'plan' || category === 'ebook'));
      if (cards.length && !categories.has(this.activeFilter)) {
        this.activeFilter = categories.has('plan') ? 'plan' : 'ebook';
      }
      const filters = this.querySelector('.iurop-recommendations__filters');
      if (filters) filters.hidden = categories.size === 0;
      this.querySelectorAll('[data-recommendation-filter]').forEach((button) => {
        const active = button.dataset.recommendationFilter === this.activeFilter;
        button.disabled = !categories.has(button.dataset.recommendationFilter);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      cards.forEach((card) => { card.hidden = card.dataset.category !== this.activeFilter; });
      const allLink = this.querySelector('.iurop-recommendations__all');
      if (allLink) allLink.href = this.activeFilter === 'ebook' ? allLink.dataset.ebooksUrl : allLink.dataset.plansUrl;
      const container = this.querySelector('.iurop-product__upsell-wrap, .iurop-recommendations');
      if (container) container.hidden = !this.querySelector('[data-upsell-product-id]');
    }
    async refresh() {
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(url, { signal: request.signal, headers: { Accept: 'text/html' }, cache: 'no-store' });
        if (!response.ok) return;
        const html = await response.text();
        if (request.signal.aborted || !this.isConnected) return;
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector(this.localName);
        if (next && next.dataset.productId === this.dataset.productId) {
          this.innerHTML = next.innerHTML;
          this.dataset.cartKey = next.dataset.cartKey;
          this.syncCards();
        }
      } catch {}
    }
    async add(button) {
      if (this.adding || button.disabled) return;
      this.adding = true;
      button.disabled = true;
      const status = this.querySelector('[data-upsell-status]');
      try {
        const response = await fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        button.closest('[data-upsell-product-id]')?.remove();
        this.syncCards();
        if (status) status.textContent = this.dataset.added;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: result }));
      } catch (error) {
        if (status) {
          status.classList.remove('visually-hidden');
          status.textContent = error.message || this.dataset.error;
        }
      } finally {
        this.adding = false;
        button.disabled = false;
      }
    }
  }
  customElements.define('cooldo-product-upsells', CooldoProductUpsells);
  customElements.define('cooldo-product-recommendations', class extends CooldoProductUpsells {});
})();
